import * as React from "react";
const SvgIncomplete = (props) => /* @__PURE__ */ React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("circle", { opacity: 0.25, cx: 12, cy: 12, r: 11.5, stroke: "currentColor" }));
export default SvgIncomplete;
